import events from './events'
import store from 'reducers'
import Actions from './Actions'

export default class PaymentActions extends Actions{
    static get target(){
        return 'payments'
    }
    static create(options){
        return this.client.payments.create(options).then((response)=>{
        })
    }
}


// WEBPACK FOOTER //
// ./actions/PaymentActions.js